import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiGetStoreInfoMethod,
    type OpenApiGetStoreInfoPathParameters,
    type OpenApiGetStoreInfoResponseSuccess,
    OpenApiGetStoreInfoUrl,
    OpenApiRequestDomainRemoderationMethod,
    type OpenApiRequestDomainRemoderationRequest,
    type OpenApiRequestDomainRemoderationResponseSuccess,
    OpenApiRequestDomainRemoderationUrl,
} from '#shared/api/schema';

const storeInfoApi = createApi({
    name: 'entities/store/api/storeInfoApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getStoreInfo: builder.query<OpenApiGetStoreInfoResponseSuccess, OpenApiGetStoreInfoPathParameters>({
                query: () => {
                    return {
                        url: OpenApiGetStoreInfoUrl,
                        method: OpenApiGetStoreInfoMethod,
                    };
                },
            }),

            requestStoreRemoderation: builder.mutation<
                OpenApiRequestDomainRemoderationResponseSuccess,
                OpenApiRequestDomainRemoderationRequest
            >({
                query: () => {
                    return {
                        url: OpenApiRequestDomainRemoderationUrl,
                        method: OpenApiRequestDomainRemoderationMethod,
                    };
                },
            }),
        };
    },
});

export const getStoreInfo = storeInfoApi.endpoints.getStoreInfo.query;
export const requestStoreRemoderation = storeInfoApi.endpoints.requestStoreRemoderation.mutate;
